export default __webpack_public_path__ + "static/media/Flowdia_Q_BG_movie.f8aae720.mov";